export const PAY_FREQUENCY_OPTIONS = ['yearly', 'monthly', 'weekly', 'daily', 'hourly'];
